import React, { useEffect, useState } from "react";
import ReactPaginate from 'react-paginate';

interface IPaginatorProps {
    pageSize: number,
    total: number,
    page: number,
    callback: (page: number) => void,
}

const Paginator: React.FC<IPaginatorProps> = ({
    pageSize,
    total,
    page,
    callback
}) => {
    const [pages, setPageCount] = useState(0);

    useEffect(() => {
        setPageCount(Math.ceil(total / pageSize));
    }, [pageSize, total]);

    const pageChangeHandler = (data: {selected: number}) => {
        callback(data.selected + 1);
    }

    // @ts-ignore
    return (
        <ReactPaginate
            breakLabel="..."
            pageCount={pages}
            nextLabel={
                <>
                    <span className="sr-only">Next</span><wbr />
                    <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
                        <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                    </svg>
                </>
            }
            previousLabel={
                <>
                    <span className="sr-only">Previous</span><wbr />
                    <svg className="h-4 w-4 fill-current" viewBox="0 0 16 16">
                        <path d="M9.4 13.4l1.4-1.4-4-4 4-4-1.4-1.4L4 8z" />
                    </svg>
                </>
            }
            forcePage={page}
            onPageChange={pageChangeHandler}
            containerClassName={'flex paginator'}
            pageClassName={'inline-flex items-center justify-center leading-5 px-3 py-2 bg-white hover:bg-indigo-500 border border-gray-200 text-gray-600 hover:text-white'}
            breakLinkClassName={'inline-flex items-center justify-center leading-5 px-3 py-2 bg-white border border-gray-200 text-gray-400'}
            nextLinkClassName={'inline-flex items-center justify-center rounded leading-5 ml-3 px-3 py-2 bg-white hover:bg-indigo-500 border border-gray-200 text-gray-600 hover:text-white shadow-sm'}
            previousLinkClassName={'inline-flex items-center justify-center rounded leading-5 mr-3 px-3 py-2 bg-white hover:bg-indigo-500 border border-gray-200 text-gray-600 hover:text-white shadow-sm'}
            activeClassName={'inline-flex items-center justify-center rounded-l leading-5 bg-white border border-gray-200 bg-indigo-500 text-white'}
            pageRangeDisplayed={2}
        />
    )

}

export default Paginator;